import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { toPercentString } from 'owa-calendar-surface-dategrid';

let styles = require('./CalendarWeekNumber.scss');

export interface CalendarWeekNumberProps {
    weekNumber: number;
    weeksInMonth: number;
}

/**
 * This panel shows date headers for surface columns
 */
const CalendarWeekNumber = observer(function CalendarWeekNumber(props: CalendarWeekNumberProps) {
    let style: React.CSSProperties = {
        height: toPercentString(1 / props.weeksInMonth),
    };
    return (
        <div style={style} className={styles.weekNumber}>
            <span className={styles.weekNumberString}>{props.weekNumber}</span>
        </div>
    );
});
export default CalendarWeekNumber;
